// this is an autogenerated file from App/Account/Content/Settings/Content/Onboarding/CsvProcedures/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Onboarding_CsvProcedures($objects: [vaxiom_procedures_insert_input!]!) {
  insert_vaxiom_procedures(objects: $objects) {
    returning {
      id
      name
    }
  }
}

`